import React from "react";
import RejectButton from "@components/FlowActionButtons/RejectButton";
import { canUserReject, type DeficiencyFlowData } from "./utils";

interface RejectDeficiencyProps {
  deficiencyFlowData?: DeficiencyFlowData;
  onReject?: () => void;
}

const LANG_BASE = "deficiencies";

const RejectDeficiency: React.FC<RejectDeficiencyProps> = ({
  deficiencyFlowData,
  onReject = () => {},
}) => {
  if (!deficiencyFlowData?.task) {
    return null;
  }

  const isActionAvailable = canUserReject(
    deficiencyFlowData.task.status,
    deficiencyFlowData.task.claimOwnerName,
    deficiencyFlowData.status,
  );

  return (
    <RejectButton
      langBase={LANG_BASE}
      permission="canResubmitFottDeficiency"
      isActionAvailable={isActionAvailable}
      onReject={onReject}
    />
  );
};

export default RejectDeficiency;
